import { DriveSection } from '@/drive/types/driveSection';
export function getDriveItemId(treeItemId) {
    return !treeItemId || treeItemId === DriveSection.MyDrive ? null : treeItemId;
}
